import loginSaga from "./Containers/Login/sagas";
import dashboardSaga from "./Containers/Dashboard/sagas";
import fileUploadSaga from "./Containers/BulkValidation/sagas";
import emailValidateSaga from "./Containers/SingleEmailValidation/sagas";
import uploadedFilesSaga from "./Containers/EmailValidation/sagas";
import pricingSaga from "./Containers/Pricing/sagas";
import settingsSaga from "./Containers/Settings/sagas";
// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield [loginSaga(), dashboardSaga(), fileUploadSaga(), emailValidateSaga(), uploadedFilesSaga(), pricingSaga(), settingsSaga()];
}



// WEBPACK FOOTER //
// ./src/sagas.js